export default __webpack_public_path__ + "media/images/logo_transparent-4b19ceabd87472794d052a6bb0a143ee.svg";